import "./Footer.css"

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">✌️ Built for the Study Hustle | Powered by AI, Styled by Gen-Z</p>
    </footer>
  )
}
